import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  statItem: {
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    width: "100%",
    // Match `AppStatsItems.totalItem` height so the Stats and Applications
    // tabs have identical card silhouettes.
    minHeight: 110,
    border: "1px solid #eef0f7",
    borderRadius: 8,
    padding: 20,
    // `cornerGlow` variant: white card with a subtle blue radial glow in
    // the top-right corner. Matches the status cards on /admin/applications.
    background:
      "radial-gradient(at 100% 0%, rgba(0, 51, 255, 0.18) 0%, transparent 70%), #fff",
    position: "relative",
    overflow: "hidden",
    // On mobile, stack the icon above the metric so longer labels
    // (e.g. "Conversion rate") have full horizontal room when there
    // are still 2 cards per row.
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
      alignItems: "flex-start",
      padding: 14,
      minHeight: 0,
    },
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#0033ff",
    height: 44,
    width: 44,
    borderRadius: 6,
    backgroundColor: "#e9edfa",
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      height: 36,
      width: 36,
    },
  },
  statNum: {
    fontSize: 26,
    fontWeight: 700,
    lineHeight: 1,
    color: "#000c3b",
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  statText: {
    marginTop: 6,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#4a5280",
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
      letterSpacing: "0.04em",
    },
  },
  statWrapper: {
    marginLeft: 14,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: 10,
    },
  },

  text: { fontSize: 16, fontWeight: 500 },

  totalAmounts: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 16,
    margin: "10px 0 20px 0",
    width: "65%",
    [theme.breakpoints.down('lg')]: {
      width: "100%",
    },
    [theme.breakpoints.down('sm')]: {
      gap: 10,
    },
  },

  mobileColumns: {
    border: "1px solid #DADFF6",
    width: "65%",
    paddingRight: 20,
    [theme.breakpoints.down('lg')]: {
      textAlign: "center",
      width: "100%",
      padding: 0,
    },
  },
  mobileTitle: { fontWeight: 600, padding: 20, display: "flex" },

  mobileInfo: { display: "flex", alignItems: "center" },
}));
